// 个人信息页面
export default {
  routes: [
    {
      path: '/personal-info',
      name: 'personalInfo',
      meta: {
        title: '已收集个人信息'
      },
      component: () =>
        import(/* webpackChunkName: "personalInfo" */ '../views/personalInfo/index.vue')
    },
    {
      path: '/personal-info-detail',
      name: 'personalInfoDetail',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "personalInfoDetail" */ '../views/personalInfo/detail.vue')
    }
  ]
}
